import { useCallback } from 'react';

export function useGenericPersistence<T>(key: string) {
  const loadState = useCallback((): T | null => {
    try {
      const serializedState = localStorage.getItem(key);
      if (serializedState === null) {
        return null;
      }
      return JSON.parse(serializedState) as T;
    } catch (error) {
      console.error('Error loading state from localStorage:', error);
      return null;
    }
  }, [key]);

  const saveState = useCallback((state: T) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem(key, serializedState);
    } catch (error) {
      console.error('Error saving state to localStorage:', error);
    }
  }, [key]);

  const clearState = useCallback(() => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Error clearing state from localStorage:', error);
    }
  }, [key]);

  return {
    loadState,
    saveState,
    clearState,
  };
}
